function TitreLog({ Title, Location }) {
  return (
    <div className="titreLogement">
      <h2>{Title}</h2>
      <p>{Location}</p>
    </div>
  )
}

export default TitreLog
